import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ignore harmless Monaco Editor promise cancellations that otherwise crash the React Error Boundary
window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && (event.reason.name === 'Canceled' || event.reason.message === 'Canceled')) {
    event.preventDefault();
  }
});

// Ignore harmless Monaco Web Worker network aborts (usually during unmount or HMR)
window.addEventListener('error', function(event) {
  if (event.message && event.message.includes("Failed to execute 'importScripts' on 'WorkerGlobalScope'")) {
    event.preventDefault();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
